/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_TitleInputs */



/**
* | output |
* | --- |
* | "Table Rooms" |
*
* @param {Rooms_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_title = /** @type {((inputs?: Rooms_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Salles")
	if (locale === "es") return /** @type {LocalizedString} */ ("Salas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Salas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sale")
	return /** @type {LocalizedString} */ ("Table Rooms")
});